import React from 'react';
import _ from 'lodash';
import { render, ReactDOM, unmountComponentAtNode } from 'react-dom';
import { Provider } from 'react-redux';
import { Alert } from 'react-bootstrap';
import configureStore, { hydrateState } from './redux/configureStore';
import Root from './App';
import ConnectionsLayout from './Integrations/connections/ConnectionsLayout';
import ErrorHandlingAppContainer from './ErrorHandlingAppContainer';

import './styles';

const elemForReact = window.document.getElementById('react-app');

const preloadedState = {
  user: {
    settings: _.pick(
      window.Drupal.settings,
      'case_lookup_default_courts',
      'pacer_search_default_case_type',
      'currentUser',
      'firmMember',
      'firmMaster',
    ),
  },
  // todo leaving below for now, but remember to refactor this out of the components in the future
  immediateSearch: window.immediateSearchArgs || {},
};

const hydratedState = hydrateState(preloadedState);
const sharedStore = configureStore(hydratedState);

if (elemForReact) {
  const renderDom = (Component) => {
    render(
      <ErrorHandlingAppContainer>
        <Provider store={sharedStore}>
          <Component />
        </Provider>
      </ErrorHandlingAppContainer>,
      elemForReact,
    );
  }

  renderDom(Root);

  if (module.hot) {
    module.hot.accept('./App', () => {
      console.info('!!!accepted hot reload!');
      const Next = require('./App').default;
      renderDom(Next);
    });
  }
}

// TODO: List of supported services should be hard-coded in the ConnectionsLayout,
// it's not something that is "configurable"
const kloudlessServices = [
  'box', 'dropbox', 'gdrive', 'skydrive','onedrivebiz'
];


window.UI = {
  mountComponent: function(dest, sourceFile, props) {
    try {
      var context = require.context("./components/case", true, /\.jsx?$/);

      console.log('mountComponent', sourceFile, 'into', dest, 'with', props);
      const c = context(sourceFile);
      const Component = c.default
      if (! Component ) throw `Unable to require('./components/case/${ sourceFile }')`;

      const store = (sourceFile.includes('docket') || sourceFile.includes('client_code_dialog'))
        ? sharedStore
        : configureStore();

      render(
        <ErrorHandlingAppContainer>
          <Provider store={store}>
            <Component {...props}/>
          </Provider>
        </ErrorHandlingAppContainer>,
        dest
      );

      module.hot && module.hot.accept(context.id, () => {
        var context = require.context("./components/case", true, /\.jsx?$/);

        console.log(`Accepted hot reload for ${sourceFile}!`);
        const NextComponent = context(sourceFile).default;
        render(
          <ErrorHandlingAppContainer>
            <Provider store={store}>
              <NextComponent {...props}/>
            </Provider>
          </ErrorHandlingAppContainer>,
          dest
        )
      });
    }
    catch (e) {
      console.log('Unable to Mount Component', e);
    }
  },
  mountIntegrationsConnections() {
    render(
      <ErrorHandlingAppContainer>
        <Provider store={sharedStore}>
          <ConnectionsLayout svc={kloudlessServices} />
        </Provider>
      </ErrorHandlingAppContainer>,
      document.getElementById('kloudless-ctrl-root'),
    );

    if (module.hot) {
      module.hot.accept('./Integrations/connections/ConnectionsLayout', () => {
        console.log('accepted hot reload! kloudless');
        const NextLayout = require('./Integrations/connections/ConnectionsLayout').default;
        render(
          <ErrorHandlingAppContainer>
            <Provider store={sharedStore}>
              <NextLayout />
            </Provider>
          </ErrorHandlingAppContainer>,
          document.getElementById('kloudless-ctrl-root'),
        );
      });
    }
  },

  automountReactComponents() {
    console.log('Looking for components to mount');
    var elements = document.querySelectorAll('.__react__component');
    for (var i = 0; i < elements.length; i++) {
      const elt = elements[i];
      console.log("About to mount react component on ", elt);
      var props = JSON.parse(elt.getAttribute('data-component-props'));
      mountReactComponent(elt, elt.getAttribute('data-component'), props);
    }
  },

  mountReactComponent: mountReactComponent,
};

// Automounting of components from the page that look like this:
// <div class="__react_component" data-component="path/to/Source.jsx" data-component-props="{PROPS}"></div>
// this is equivalent to mounting <Source ...PROPS />

function mountReactComponent(dest, sourceFile, props) {
  try {
    var context = require.context("./", true, /\.jsx$/);

    console.log('mountComponent', sourceFile, 'with props', props, 'into', dest);
    const Component = context(sourceFile).default;
    if (! Component ) throw `Unable to require('./${ sourceFile }')`;

    render(
      <ErrorHandlingAppContainer>
        <Provider store={sharedStore}>
          <Component {...props}/>
        </Provider>
      </ErrorHandlingAppContainer>,
      dest
    );

    module.hot && module.hot.accept(context.id, () => {
      var context = require.context("./", true, /\.jsx$/);

      console.log(`Accepted hot reload for ${sourceFile}!`);
      const NextComponent = context(sourceFile).default;
      render(
        <ErrorHandlingAppContainer>
          <Provider store={sharedStore}>
            <NextComponent {...props}/>
          </Provider>
        </ErrorHandlingAppContainer>,
        dest
      )
    });
  }
  catch (e) {
    console.log('Unable to Mount Component', e);
  }
}

UI.automountReactComponents();

// // leaving here for now
// if (window.location.href.indexOf('#tab-menu') !== -1 && window.Drupal.settings.has_dockets) {
//   const segments = window.location.href.split('/');
//   const case_uuid = segments[segments.length - 1].split('-')[0];
//   window.openTab('query-ajax', 'dockets', 'Docket', case_uuid, false, '#dockets');
// }



// WEBPACK FOOTER //
// ./src/index.jsx